module.exports = __webpack_public_path__ + "media/standalone/envelope-1b224a1e.svg";